// Module
var code = "<p>If you have loans enrolled in Direct Debit, you will receive a Monthly Direct Debit Statement 21 days prior to the withdrawal date.</p> ";
// Exports
export default code;